@if (!isMobile) {
  <div class="section-top-header ui-mobile-AirDisc">Value Calculator</div>
}
@if (isMobile) {
  <div class="section-top-header ui-mobile-AirDisc"  (click)="iconToggler =! iconToggler">{{ 'common.airDisc_value_calculator_title' | cxTranslate }}</div>
}
@if (isMobile?!iconToggler:true) {
  <ul class="my-account-nav mobile-account-nav" >
    <li class="parentLI">
      <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'visitorInfo'?'active':''" href="#visitorInfo" (click)="SelectedComponent('visitorInfo',$event)">{{ 'common.value_calculator_visitor_info_title' | cxTranslate }}
        @if (currentComponent === 'visitorInfo') {
          <img src="/icons/link-right-blue.svg" class="right-arrow">
        }</a>
      </li>
      <li class="parentLI">
        <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'fleetInfo'?'active':''"  href="#fleetInfo" (click)="SelectedComponent('fleetInfo',$event)">{{ 'common.value_calculator_flit_info_title' | cxTranslate }}
          @if (currentComponent === 'fleetInfo') {
            <img src="/icons/link-right-blue.svg" class="right-arrow">
          }</a>
        </li>
        <li class="parentLI">
          <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'replacementCost'?'active':''"href="#replacementCost" (click)="SelectedComponent('replacementCost',$event)">{{ 'common.value_calculator_replacement_costNode_title' | cxTranslate }}
            @if (currentComponent === 'replacementCost') {
              <img src="/icons/link-right-blue.svg" class="right-arrow">
            }</a>
          </li>
          <li class="parentLI">
            <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'currentProduct'?'active':''" href="#currentProduct" (click)="SelectedComponent('currentProduct',$event)">{{ 'common.value_calculator_product_performance_title' | cxTranslate }}
              @if (currentComponent === 'currentProduct') {
                <img src="/icons/link-right-blue.svg" class="right-arrow">
              }</a>
            </li>
            <li class="parentLI">
              <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'csaDowntime'?'active':''" href="#csaDowntime" (click)="SelectedComponent('csaDowntime',$event)">{{ 'common.value_calculator_csa_title' | cxTranslate }}
                @if (currentComponent === 'csaDowntime') {
                  <img src="/icons/link-right-blue.svg" class="right-arrow">
                }</a>
              </li>
              <li class="parentLI">
                <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'endurasurePro'?'active':''"href="#endurasurePro" (click)="SelectedComponent('endurasurePro',$event)">{{ 'common.value_calculator_upcharge_title' | cxTranslate }}
                  @if (currentComponent === 'endurasurePro') {
                    <img src="/icons/link-right-blue.svg" class="right-arrow">
                  }</a>
                </li>
                <li class="parentLI">
                  <a class="my-account-nav-item-link" [ngClass]="currentComponent === 'endurasureSummary'?'active':''" href="#endurasureSummary" (click)="SelectedComponent('endurasureSummary',$event)">{{ 'common.value_calculator_enduraSure_summary' | cxTranslate }}
                    @if (currentComponent === 'endurasureSummary') {
                      <img src="/icons/link-right-blue.svg" class="right-arrow">
                    }</a>
                  </li>
                </ul>
              }
